import React from 'react';
import { FilterDateRange } from '../molecules/FilterDateRange';
/**
 * Shared date range filter organism.
 * Wrap with FilterGroup at the page level.
 */
export function DateRangeFilter({ value, onChange }) {
    return React.createElement(FilterDateRange, { value: value, onChange: onChange });
}
